class VatValidator extends HTMLElement {

  static hungarianTaxRegex = /^((\d{8}\-[1-5]\-(?:0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51))|(hu|HU)\d{8}){1}$/;
  
  constructor() {
    super();

    this.privateTypeRadio = this.querySelector("#vat-validator-private");
    this.companyTypeRadio = this.querySelector("#vat-validator-company");
    this.companyDataContainer = this.querySelector(".vat-validator__company-details");

    this.privateTypeRadio.addEventListener("click", (e) => {
      e.stopPropagation();
      this.privateTypeChecked();
    });
    this.companyTypeRadio.addEventListener("click", (e) => {
      e.stopPropagation();
      this.companyTypeChecked();
    });

    this.privateTypeRadio.closest(".vat-validator__type-selector--option")
      .addEventListener("click", () => {
        this.privateTypeRadio.checked = true;
        this.privateTypeChecked();
      });
    this.companyTypeRadio.closest(".vat-validator__type-selector--option")
      .addEventListener("click", () => {
        this.companyTypeRadio.checked = true;
        this.companyTypeChecked();
      });

    // Auto-format VAT input: numbers only, Hungarian format XXXXXXXX-X-XX
    const vatInput = this.querySelector("#vat-validator-vat-number");
    vatInput.addEventListener("input", (e) => {
      let digits = vatInput.value.replace(/\D/g, "");
      let formatted = "";

      if (digits.length <= 8) {
        formatted = digits;
      } else if (digits.length === 9) {
        formatted = digits.slice(0, 8) + "-" + digits.slice(8, 9);
      } else {
        formatted = digits.slice(0, 8) + "-" + digits.slice(8, 9) + "-" + digits.slice(9, 11);
      }

      // Cap at 11 digits total (8 + 1 + 2)
      const digitCount = formatted.replace(/\D/g, "").length;
      if (digitCount > 11) return;

      vatInput.value = formatted;
    });

 vatInput.addEventListener("keydown", (e) => {
  const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
  if (allowed.includes(e.key)) return;
  // Allow Ctrl+V, Cmd+V, Ctrl+A, Cmd+A, Ctrl+C, Cmd+C
  if (e.ctrlKey || e.metaKey) return;
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
  }
});
  }

  privateTypeChecked() {
    this.companyTypeRadio.checked = false;
    this.changeSelectedType("private");
    VatValidator.hideAllErrors(this);
  }

  companyTypeChecked() {
    this.privateTypeRadio.checked = false;
    this.changeSelectedType("company");
  }

  changeSelectedType(selectedType) {
    this.setAttribute("data-type-selected", selectedType);
  }

  static hideAllErrors(vatNode) {
    vatNode.querySelectorAll(".vat-validator__error").forEach((element) => {
      element.style.display = "none";
    })
  }

  static async saveVatNumber(vatNumber) {
    let shippingItemVariants = {
      "attributes": {
        "tax-number": vatNumber
      }
    };
    await fetch('/cart/update.js', {method: "POST", headers: { "Content-type": "application/json"}, body: JSON.stringify(shippingItemVariants)});
  }

  static async validateVAT(vatNode) {
    VatValidator.hideAllErrors(vatNode);

    if (vatNode.querySelector("#vat-validator-private").checked == false && vatNode.querySelector("#vat-validator-company").checked == false) {
      vatNode.querySelector("#vat-validator-error-not-selected").style.display = "block";
      return false;
    }
    
    let isPrivateTypeSelected = vatNode.querySelector("#vat-validator-private").checked;
    if (isPrivateTypeSelected == true) {
      await VatValidator.saveVatNumber("");
      return true;
    }
    else {
      let enteredVatNumber = vatNode.querySelector("#vat-validator-vat-number").value;
      let countrySelectorValue = vatNode.querySelector("#vat-validator-country")?.value;

      if (enteredVatNumber.length < 8 && countrySelectorValue == "HU") {
        vatNode.querySelector("#vat-validator-error-invalid").style.display = "block";
        await VatValidator.saveVatNumber("");
        return false;
      }

      if (!countrySelectorValue || countrySelectorValue == "HU") {
        if (!enteredVatNumber.match(VatValidator.hungarianTaxRegex)) {
          vatNode.querySelector("#vat-validator-error-invalid").style.display = "block";
          await VatValidator.saveVatNumber("");
          return false;
        } else {
          await VatValidator.saveVatNumber(enteredVatNumber);
          return true;
        }
      } else {
        let isValid = false;
        let request = await fetch(`https://api.vatcheckapi.com/v2/check?vat_number=${countrySelectorValue}${enteredVatNumber}&apikey=vat_live_lawWf1MePpD8edt7mKsrW9Q2Wi4qR1Dkol5AUUBk`)
        .then(blob => blob.json())
        .then(data => {
          if ((data.success == true) || (data.registration_info?.is_registered == true)) {
            isValid = true;
          } else {
            vatNode.querySelector("#vat-validator-error-invalid").style.display = "block";
          }
        })
        if (isValid) {
          await VatValidator.saveVatNumber(enteredVatNumber);
        }
        return isValid;
      }
    }
  }
}

window.customElements.define("vat-validator", VatValidator);